/**
 * @generated SignedSource<<5efdd68917dd28853269a0dae5b75eec>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
export type FormMetadataStyleEnum = "ImageCenter" | "ImageLeft" | "NoImage";
export type FormMetadataTemplateEnum = "Basic" | "CompanyLong" | "CompanyShort" | "PasswordProtected" | "PasswordProtectedShort";
export type PostStatusEnum = "ACF_DISABLED" | "AUTO_DRAFT" | "DRAFT" | "FUTURE" | "HIDDEN" | "HIDDEN_B_S" | "INHERIT" | "PENDING" | "PRIVATE" | "PUBLISH" | "REQUEST_COMPLETED" | "REQUEST_CONFIRMED" | "REQUEST_FAILED" | "REQUEST_PENDING" | "TRASH";
export type StatusUiPermissionEnum = "PUBLIC" | "RESTRICTED";
import { FragmentRefs } from "relay-runtime";
export type GCP_VertexSearchPagination_Fragment$data = {
  readonly vertexSearchAgent: {
    readonly correctedQuery: string | null | undefined;
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly author: {
          readonly node: {
            readonly id: string;
            readonly name: string | null | undefined;
            readonly slug: string | null | undefined;
            readonly username: string | null | undefined;
          };
        } | null | undefined;
        readonly databaseId: number;
        readonly id: string;
        readonly link: string | null | undefined;
        readonly searchResults: {
          readonly extractiveAnswers: ReadonlyArray<{
            readonly content: string | null | undefined;
            readonly pageNumber: string | null | undefined;
          } | null | undefined> | null | undefined;
          readonly snippets: ReadonlyArray<{
            readonly snippet: string | null | undefined;
          } | null | undefined> | null | undefined;
        } | null | undefined;
        readonly status: string | null | undefined;
        readonly statusSettings: {
          readonly approved: {
            readonly id: string | null | undefined;
            readonly timestamp: string | null | undefined;
            readonly user: {
              readonly name: string | null | undefined;
            } | null | undefined;
          } | null | undefined;
          readonly stateWhenApproved: {
            readonly status: PostStatusEnum | null | undefined;
            readonly uiPermission: {
              readonly type: StatusUiPermissionEnum | null | undefined;
            } | null | undefined;
          } | null | undefined;
          readonly status: PostStatusEnum | null | undefined;
          readonly uiPermission: {
            readonly type: StatusUiPermissionEnum | null | undefined;
          } | null | undefined;
        } | null | undefined;
        readonly title: string | null | undefined;
        readonly znglyContent: {
          readonly aiSummary: string | null | undefined;
          readonly contentEmbedHtml: string | null | undefined;
          readonly contentFile: {
            readonly mediaDetails: {
              readonly sizes: ReadonlyArray<{
                readonly name: string | null | undefined;
                readonly sourceUrl: string | null | undefined;
              } | null | undefined> | null | undefined;
            } | null | undefined;
            readonly mediaItemUrl: string | null | undefined;
          } | null | undefined;
          readonly contentLink: string | null | undefined;
          readonly contentMediaName: string | null | undefined;
          readonly contentMediaType: string | null | undefined;
          readonly ctaLink: string | null | undefined;
          readonly ctaName: string | null | undefined;
          readonly featuredImageFile: {
            readonly mediaDetails: {
              readonly sizes: ReadonlyArray<{
                readonly name: string | null | undefined;
                readonly sourceUrl: string | null | undefined;
              } | null | undefined> | null | undefined;
            } | null | undefined;
            readonly mediaItemUrl: string | null | undefined;
          } | null | undefined;
          readonly featuredImageLink: string | null | undefined;
          readonly form: {
            readonly node: {
              readonly content: string | null | undefined;
              readonly id: string;
              readonly imageUrl: string | null | undefined;
              readonly marketingConsent: boolean | null | undefined;
              readonly metadata: {
                readonly cookieExpiration: string | null | undefined;
                readonly formStyle: FormMetadataStyleEnum | null | undefined;
                readonly formTemplate: FormMetadataTemplateEnum | null | undefined;
                readonly submitSuccessText: string | null | undefined;
              } | null | undefined;
              readonly password: boolean | null | undefined;
              readonly schema: string | null | undefined;
              readonly title: string;
              readonly uiSchema: string | null | undefined;
            };
          } | null | undefined;
          readonly htmlDesc: string | null | undefined;
          readonly shortText: string | null | undefined;
        } | null | undefined;
      };
    }>;
    readonly summary: {
      readonly summaryText: string | null | undefined;
      readonly summaryWithMetadata: {
        readonly citationMetadata: {
          readonly citations: ReadonlyArray<{
            readonly endIndex: number | null | undefined;
            readonly sources: ReadonlyArray<{
              readonly referenceIndex: string | null | undefined;
            } | null | undefined> | null | undefined;
            readonly startIndex: number | null | undefined;
          } | null | undefined> | null | undefined;
        } | null | undefined;
        readonly references: ReadonlyArray<{
          readonly document: string | null | undefined;
          readonly title: string | null | undefined;
        } | null | undefined> | null | undefined;
        readonly summary: string | null | undefined;
      } | null | undefined;
    } | null | undefined;
  } | null | undefined;
  readonly " $fragmentType": "GCP_VertexSearchPagination_Fragment";
};
export type GCP_VertexSearchPagination_Fragment$key = {
  readonly " $data"?: GCP_VertexSearchPagination_Fragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"GCP_VertexSearchPagination_Fragment">;
};

import GCP_VertexSearchPagination_Query_graphql from './GCP_VertexSearchPagination_Query.graphql';

const node: ReaderFragment = (function(){
var v0 = [
  "vertexSearchAgent"
],
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "title",
  "storageKey": null
},
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "status",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "concreteType": "UIPermission",
  "kind": "LinkedField",
  "name": "uiPermission",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "type",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "content",
  "storageKey": null
},
v7 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "mediaItemUrl",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "concreteType": "MediaDetails",
    "kind": "LinkedField",
    "name": "mediaDetails",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "MediaSize",
        "kind": "LinkedField",
        "name": "sizes",
        "plural": true,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "sourceUrl",
            "storageKey": null
          },
          (v3/*: any*/)
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "argumentDefinitions": [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "after"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "first"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "where"
    }
  ],
  "kind": "Fragment",
  "metadata": {
    "connection": [
      {
        "count": "first",
        "cursor": "after",
        "direction": "forward",
        "path": (v0/*: any*/)
      }
    ],
    "refetch": {
      "connection": {
        "forward": {
          "count": "first",
          "cursor": "after"
        },
        "backward": null,
        "path": (v0/*: any*/)
      },
      "fragmentPathInResult": [],
      "operation": GCP_VertexSearchPagination_Query_graphql
    }
  },
  "name": "GCP_VertexSearchPagination_Fragment",
  "selections": [
    {
      "alias": "vertexSearchAgent",
      "args": [
        {
          "kind": "Variable",
          "name": "where",
          "variableName": "where"
        }
      ],
      "concreteType": "VertexSearchAgentConnection",
      "kind": "LinkedField",
      "name": "__GCP_Pagination_vertexSearchAgent_connection",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "correctedQuery",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "Summary",
          "kind": "LinkedField",
          "name": "summary",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "summaryText",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "SummaryWithMetadata",
              "kind": "LinkedField",
              "name": "summaryWithMetadata",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "summary",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "CitationMetadata",
                  "kind": "LinkedField",
                  "name": "citationMetadata",
                  "plural": false,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "Citation",
                      "kind": "LinkedField",
                      "name": "citations",
                      "plural": true,
                      "selections": [
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "startIndex",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "endIndex",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "concreteType": "CitationSource",
                          "kind": "LinkedField",
                          "name": "sources",
                          "plural": true,
                          "selections": [
                            {
                              "alias": null,
                              "args": null,
                              "kind": "ScalarField",
                              "name": "referenceIndex",
                              "storageKey": null
                            }
                          ],
                          "storageKey": null
                        }
                      ],
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "SummaryReference",
                  "kind": "LinkedField",
                  "name": "references",
                  "plural": true,
                  "selections": [
                    (v1/*: any*/),
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "document",
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "VertexSearchAgentConnectionEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "ZnglyVideo",
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": [
                (v2/*: any*/),
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "NodeWithAuthorToUserConnectionEdge",
                  "kind": "LinkedField",
                  "name": "author",
                  "plural": false,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "User",
                      "kind": "LinkedField",
                      "name": "node",
                      "plural": false,
                      "selections": [
                        (v2/*: any*/),
                        (v3/*: any*/),
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "username",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "slug",
                          "storageKey": null
                        }
                      ],
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "databaseId",
                  "storageKey": null
                },
                (v1/*: any*/),
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "link",
                  "storageKey": null
                },
                (v4/*: any*/),
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "StatusSettings",
                  "kind": "LinkedField",
                  "name": "statusSettings",
                  "plural": false,
                  "selections": [
                    (v4/*: any*/),
                    (v5/*: any*/),
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "StateWhenApproved",
                      "kind": "LinkedField",
                      "name": "stateWhenApproved",
                      "plural": false,
                      "selections": [
                        (v4/*: any*/),
                        (v5/*: any*/)
                      ],
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "ApprovedState",
                      "kind": "LinkedField",
                      "name": "approved",
                      "plural": false,
                      "selections": [
                        (v2/*: any*/),
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "timestamp",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "concreteType": "User",
                          "kind": "LinkedField",
                          "name": "user",
                          "plural": false,
                          "selections": [
                            (v3/*: any*/)
                          ],
                          "storageKey": null
                        }
                      ],
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "AiSearchResults",
                  "kind": "LinkedField",
                  "name": "searchResults",
                  "plural": false,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "Snippet",
                      "kind": "LinkedField",
                      "name": "snippets",
                      "plural": true,
                      "selections": [
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "snippet",
                          "storageKey": null
                        }
                      ],
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "ExtractiveAnswer",
                      "kind": "LinkedField",
                      "name": "extractiveAnswers",
                      "plural": true,
                      "selections": [
                        (v6/*: any*/),
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "pageNumber",
                          "storageKey": null
                        }
                      ],
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "ZnglyVideo_Znglycontent",
                  "kind": "LinkedField",
                  "name": "znglyContent",
                  "plural": false,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "aiSummary",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "ctaLink",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "ctaName",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "contentMediaType",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "contentLink",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "contentEmbedHtml",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "contentMediaName",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "MediaItem",
                      "kind": "LinkedField",
                      "name": "contentFile",
                      "plural": false,
                      "selections": (v7/*: any*/),
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "featuredImageLink",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "MediaItem",
                      "kind": "LinkedField",
                      "name": "featuredImageFile",
                      "plural": false,
                      "selections": (v7/*: any*/),
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "shortText",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "htmlDesc",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "ZnglyVideo_ZnglycontentToFormConnectionEdge",
                      "kind": "LinkedField",
                      "name": "form",
                      "plural": false,
                      "selections": [
                        {
                          "alias": null,
                          "args": null,
                          "concreteType": "Form",
                          "kind": "LinkedField",
                          "name": "node",
                          "plural": false,
                          "selections": [
                            (v2/*: any*/),
                            (v1/*: any*/),
                            (v6/*: any*/),
                            {
                              "alias": null,
                              "args": null,
                              "kind": "ScalarField",
                              "name": "schema",
                              "storageKey": null
                            },
                            {
                              "alias": null,
                              "args": null,
                              "kind": "ScalarField",
                              "name": "uiSchema",
                              "storageKey": null
                            },
                            {
                              "alias": null,
                              "args": null,
                              "concreteType": "FormMetadata",
                              "kind": "LinkedField",
                              "name": "metadata",
                              "plural": false,
                              "selections": [
                                {
                                  "alias": null,
                                  "args": null,
                                  "kind": "ScalarField",
                                  "name": "formStyle",
                                  "storageKey": null
                                },
                                {
                                  "alias": null,
                                  "args": null,
                                  "kind": "ScalarField",
                                  "name": "formTemplate",
                                  "storageKey": null
                                },
                                {
                                  "alias": null,
                                  "args": null,
                                  "kind": "ScalarField",
                                  "name": "cookieExpiration",
                                  "storageKey": null
                                },
                                {
                                  "alias": null,
                                  "args": null,
                                  "kind": "ScalarField",
                                  "name": "submitSuccessText",
                                  "storageKey": null
                                }
                              ],
                              "storageKey": null
                            },
                            {
                              "alias": null,
                              "args": null,
                              "kind": "ScalarField",
                              "name": "marketingConsent",
                              "storageKey": null
                            },
                            {
                              "alias": null,
                              "args": null,
                              "kind": "ScalarField",
                              "name": "password",
                              "storageKey": null
                            },
                            {
                              "alias": null,
                              "args": null,
                              "kind": "ScalarField",
                              "name": "imageUrl",
                              "storageKey": null
                            }
                          ],
                          "storageKey": null
                        }
                      ],
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "__typename",
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "cursor",
              "storageKey": null
            }
          ],
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "VertexSearchAgentConnectionPageInfo",
          "kind": "LinkedField",
          "name": "pageInfo",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "endCursor",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "hasNextPage",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "RootQuery",
  "abstractKey": null
};
})();

(node as any).hash = "0211030a3b5418362c6dc4aaa8a80be8";

export default node;
